export default {"src":"/_next/static/media/arrows.402ad60c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};